import type { FormValues } from './types';

export const DEFAULT_VALUES: FormValues = {
  services: [],
  contactId: null,
  description: '',
  startDate: null,
  noShow: false
}